export const castArray = (item) => Array.isArray(item) ? item : [item];

export const generateArray = (length) => Array.from({ length }, (_, i) => i + 1);